import { CommonModule } from '@angular/common';
import {
  ApplicationRef,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnChanges,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbCarousel, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { map, take } from 'rxjs/operators';

import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { arraySlices } from 'ish-core/utils/functions';
import { whenTruthy } from 'ish-core/utils/operators';
import { ContentPageletComponent } from 'ish-shared/cms/components/content-pagelet/content-pagelet.component';
import { ContentSlotComponent } from 'ish-shared/cms/components/content-slot/content-slot.component';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';

@Component({
  selector: 'ish-cms-carousel',
  templateUrl: './cms-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgbCarouselModule, ContentSlotComponent, ContentPageletComponent],
})
export class CMSCarouselComponent implements CMSComponent, OnChanges {
  private appRef = inject(ApplicationRef);

  readonly pagelet = input.required<ContentPageletView>();

  readonly carousel = viewChild<NgbCarousel>('ngbCarousel');

  private slideItems = 6;
  itemGridSize = 12;
  pageletSlides: string[][] = [];

  private destroyRef = inject(DestroyRef);

  ngOnChanges() {
    const pagelet = this.pagelet();
    if (pagelet.hasParam('SlideItems')) {
      this.slideItems = pagelet.numberParam('SlideItems');
    }
    this.itemGridSize = (12 - (12 % this.slideItems)) / this.slideItems;

    const slotPagelets = pagelet.slot('app_sf_base_cm:slot.carousel.items.pagelet2-Slot').pageletIDs;
    this.pageletSlides = arraySlices(slotPagelets, this.slideItems);

    if (!SSR) {
      this.appRef.isStable
        .pipe(
          whenTruthy(),
          map(() => {
            const pageletValue = this.pagelet();
            return pageletValue.booleanParam('StartCycling') ? pageletValue.numberParam('SlideInterval', 5000) : 0;
          }),
          take(1),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(val => {
          const carousel = this.carousel();
          if (val && carousel) {
            carousel.interval = val;
            carousel.cycle();
          }
        });
    }
  }
}
